import React from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import SliderButton from '@common/sliderButton';
import DateUtil from '@utils/date/util';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const PrevArrow = (props: any) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'prev'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnPrev')}
    />
  );
};

const NextArrow = (props: any) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'next'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnNext')}
    />
  );
};

const BannerList = [
  {
    url: '/img/v2/components/event/imgBanner1.png',
    href: '/event/profile',
    endTime: '2024-01-31 23:59:59',
  },
];

const settings = {
  className: BannerList.length === 1 ? 'slider variable-width center' : 'slider variable-width',
  centerMode: BannerList.length > 1,
  variableWidth: true,
  infinite: true,
  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 700,
  cssEase: 'ease-in-out',
  draggable: true,
};

const EventBanner = () => {
  const bannerEls = BannerList.filter(({ endTime }) => (endTime ? !DateUtil.isPastDate(new Date(endTime)) : true)).map(
    ({ url, href }, index) => {
      return (
        <div key={index} className={cx('bannerWrap')}>
          <Link href={href} legacyBehavior>
            <a
              target={'_blank'}
              className={cx('banner')}
              style={{ width: 1200, backgroundImage: `url(${url})` }}
              role={'button'}
            />
          </Link>
        </div>
      );
    },
  );

  return (
    <div className={cx('bannerArea')}>
      <Slider {...settings}>{bannerEls}</Slider>
    </div>
  );
};

export default EventBanner;
